import pluginCommonMethods from './../../shopDiagnosis/mixin/pluginCommonMethods.js';
export default {
    name: 'pluginsAnalysis',
    data() {
        return {
            taskId: '',
            pluginData: [],
        };
    },
    computed: {
        queryType() {
            let path = this.$route.name;
            let type;
            switch (path) {
                case 'shopRankingQuery':
                    type = 1;
                    break;
                case 'productionRankingQuery':
                    type = 2;
                    break;
                case 'keywordsRankingQuery':
                    type = 3;
                    break;
            }
            return type;
        },
    },
    mixins: [pluginCommonMethods],
    methods: {
        // 生成排行查询记录
        async saveRankedQuery(data) {
            this.resetData(); // 重置数据
            this.taskId = '';

            let { keywords } = data;

            await this.getKeywordNum();

            const restNum = this.totalNum - this.usedNum;
            const len = keywords.length;
            if (restNum === 0) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `今日关键词查询数量仅剩 <em style='color: red;'>0</em> 个，请明天再来查询`,
                    type: 'warning',
                });
                return;
            } else if (len > restNum) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `今日关键词查询数量仅剩 <em style='color: red;'>${restNum}</em> 个，请减少本次关键词查询个数`,
                    type: 'warning',
                });
                return;
            }

            // 提交每日查询限额
            await this.$ajax.post('app/api/ca/ModifyAnalysisSetting', { increment: len });

            let ajaxData = {
                keyWords: keywords,
                queryType: this.shopName ? 1 : this.offerId ? 2 : 3,
                queryPage: this.queryPage + 1, // 查询页码
            };
            if (this.getShopInfo && this.getShopInfo.CompanyName) {
                ajaxData.shopName = this.getShopInfo.CompanyName;
            }
            if (this.offerId) {
                ajaxData.queryLink = this.proLink;
            }
            this.loading = true;

            this.$ajax.post('fw/api/v1/RankedQuery/Save', ajaxData).then((res) => {
                let { code, msg, result } = res;
                if (code !== 200) {
                    return this.$message.warning(msg);
                }
                this.taskId = result.taskId; // 先获取任务ID
                this.getPluginData(data);
            });
        },

        // 获取插件数据
        async getPluginData({ keywords }) {
            let saveArr = [];

            for (let i = 0; i < keywords.length; i++) {
                this.loadingText = `正在排名查询 ${keywords[i]},请耐心等待...`;
                if (this.queryPage === 0) {
                    // 1-120个
                    for (let j = 0; j < 2; j++) {
                        let res = await window?.dsToolsPlugin?.rankingQuery?.keywordSearch({
                            keywords: keywords[i],
                            pageIndex: j, // 当前页
                            pageSize: 60,
                        });
                        if (res.code !== 200) {
                            this.$message.warning(res.message);
                            break;
                        }
                        saveArr = [
                            ...saveArr,
                            ...this.handlePluginData({ list: res.result.offerList, keyword: keywords[i] }),
                        ];
                    }
                } else {
                    // 1-200个
                    for (let j = 0; j < 4; j++) {
                        let res = await window?.dsToolsPlugin?.rankingQuery?.keywordSearch({
                            keywords: keywords[i],
                            pageIndex: j, // 当前页
                            pageSize: 50,
                        });
                        if (res.code !== 200) {
                            this.$message.warning(res.message);
                            break;
                        }
                        saveArr = [
                            ...saveArr,
                            ...this.handlePluginData({ list: res.result.offerList, keyword: keywords[i] }),
                        ];
                    }
                }
            }
            this.loading = false;
            saveArr = saveArr.map((item) => {
                return {
                    keyword: item.keyword, // 关键词
                    ProductInfo: {
                        ProductId: item.offerId,
                        Image: {
                            images: [item.image],
                        },
                        QualityLevel: '', // 星级
                    },
                    title: item.title.replace(item.keyword, '<font style="color: red;">' + item.keyword + '</font>'), // 产品标题
                    LastUpdateTime: '', // 更新时间
                    shilitag: item.power, // 实力商家
                    companyTag: item.tpYearNum + '年', // 诚信通年限
                    tradeBt: item.gmvPrice30d ? item.gmvPrice30d : '-', // 30天成交额
                    type: item.isP4P ? '网销宝' : '自然搜索',
                    pageIndex: item.order, // 第几个
                    detailUrl: item.detailUrl,
                };
            });
            this.tableData = saveArr;
            this.$refs.rankListV2.searchFail = true;
            this.getKeywordNum();
        },

        // 同步详细日志
        saveRankedQueryDetails(data) {
            this.$ajax.post('fw/api/v1/RankedQuery/SaveRankedQueryDetails', data);
        },

        handlePluginData({ list, keyword }) {
            const shopName = this.shopName; // 店铺地址
            const offerId = this.offerId; // 产品 id
            let arr = [];
            if (shopName) {
                // 全店产品排名查询
                const WangWang = this.getShopInfo.WangWang;
                arr = list.filter((v) => {
                    if (v.loginId === WangWang) {
                        v.keyword = keyword;
                        return true;
                    }
                    return false;
                });
            } else if (offerId) {
                // 单产品排名查询
                arr = list.filter((v) => {
                    if (v.offerId + '' === offerId) {
                        v.keyword = keyword;
                        return true;
                    }
                    return false;
                });
            } else {
                // 关键词排名查询
                arr = list.map((v) => {
                    return {
                        ...v,
                        keyword,
                    };
                });
            }
            if (arr.length) {
                this.saveRankedQueryDetails({
                    keyWord: keyword,
                    data: arr,
                    taskId: this.taskId,
                });
            }
            return arr;
        },
    },
};
